module.exports = __webpack_public_path__ + "static/media/dropdown.2cdc3a81.svg";